import getDiagnosticReportStudyId from './getDiagnosticReportStudyId';

const getStudyDiagnosticReports = ({ studyId, diagnosticReports }) =>
	diagnosticReports?.filter(diagnosticReport => {
		const diagnosticReportStudyId = getDiagnosticReportStudyId(diagnosticReport);
		return studyId === diagnosticReportStudyId;
	}) || [];

export default getStudyDiagnosticReports;
